import { DateTime } from 'luxon';
import { OrderFieldsFragment } from '../../../graphql';

export const formatTimePlaced = (
	timePlaced: OrderFieldsFragment['timePlaced']
): string => DateTime.fromISO(timePlaced).toFormat("M/d/yy 'at' h:mm a");
